<div class="modal-backdrop">
  <div class="modal-container">
    <div class="modal">
      <div class="modal-header">
        <h3 class="modal-title">Detalhes do Plano #{{ data.plan.id }}</h3>
      </div>

      <mat-dialog-content class="modal-body">
        <div class="plan-details">
          <!-- Informações do Plano -->
          <div class="info-section">
            <div class="title-section">Informações Gerais</div>
            
            <div class="info-row">
              <span class="info-label">ID:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ data.plan.id }}</span>
            </div>
            
            <div class="info-row">
              <span class="info-label">CPF/CNPJ:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ formatCpfCnpj(data.plan.cpfcnpj) }}</span>
            </div>
            
            <div class="info-row" *ngIf="data.plan.packageType">
              <span class="info-label">Tipo de Pacote:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ data.plan.packageType }}</span>
            </div>
            
            <div class="info-row" *ngIf="data.plan.payerCnpj">
              <span class="info-label">CNPJ do Pagador:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ formatCpfCnpj(data.plan.payerCnpj) }}</span>
            </div>
            
            <div class="info-row">
              <span class="info-label">Renovação Automática:</span>
              <span class="info-separator"></span>
              <span class="badge" [ngClass]="data.plan.autoRenew ? 'badge-success' : 'badge-default'">
                {{ data.plan.autoRenew ? 'Sim' : 'Não' }}
              </span>
            </div>
            
            <div class="info-row">
              <span class="info-label">Status:</span>
              <span class="info-separator"></span>
              <span class="badge" [ngClass]="data.plan.active ? 'badge-success' : 'badge-error'">
                {{ data.plan.active ? 'Ativo' : 'Inativo' }}
              </span>
            </div>
          </div>

          <!-- Total do Plano -->
          <div class="card card-dark total-section">
            <div class="total-content">
              <div>
                <strong>Valor Total do Plano</strong>
                <p>Inclui todos os itens e descontos aplicados</p>
              </div>
              <div class="total-value">
                {{ formatPrice(data.planTotal) }}
              </div>
            </div>
          </div>

          <mat-divider></mat-divider>

          <!-- ITENS DO PLANO -->
          <div class="items-section">
            <div class="title-section">Itens do Plano ({{ getItemsCount() }})</div>

            <div *ngIf="data.plan.items && data.plan.items.length > 0; else noItems">
              <table mat-table [dataSource]="data.plan.items" class="items-table">
                <ng-container matColumnDef="product">
                  <th mat-header-cell *matHeaderCellDef>Produto</th>
                  <td mat-cell *matCellDef="let item">ID: {{ item.product.id }} - {{ item.product.name }}</td>
                </ng-container>

                <ng-container matColumnDef="quantity">
                  <th mat-header-cell *matHeaderCellDef>Quantidade</th>
                  <td mat-cell *matCellDef="let item">{{ item.quantity }}</td>
                </ng-container>

                <ng-container matColumnDef="unitPrice">
                  <th mat-header-cell *matHeaderCellDef>Preço Unitário</th>
                  <td mat-cell *matCellDef="let item">{{ formatPrice(item.unitPrice) }}</td>
                </ng-container>

                <ng-container matColumnDef="finalPrice">
                  <th mat-header-cell *matHeaderCellDef>Preço Final</th>
                  <td mat-cell *matCellDef="let item">{{ formatPrice(item.finalPrice) }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['product','quantity','unitPrice','finalPrice']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['product','quantity','unitPrice','finalPrice'];"></tr>
              </table>
            </div>

            <ng-template #noItems>
              <p class="empty-message">Nenhum item adicionado</p>
            </ng-template>
          </div>

          <mat-divider></mat-divider>

          <!-- DESCONTOS DO PLANO -->
          <div class="discounts-section">
            <div class="title-section">Descontos ({{ getDiscountsCount() }})</div>

            <div *ngIf="data.plan.discounts && data.plan.discounts.length > 0; else noDiscounts">
              <div class="discounts-list">
                <div class="card discount-card" *ngFor="let discount of data.plan.discounts">
                  <div class="discount-header">
                    <strong>{{ discount.description }}</strong>
                  </div>

                  <div class="discount-details">
                    <div class="detail-item">
                      <small>Tipo:</small>
                      <p>{{ getDiscountTypeLabel(discount) }}</p>
                    </div>

                    <div class="detail-item">
                      <small>Valor:</small>
                      <p class="highlight">{{ getDiscountValue(discount) }}</p>
                    </div>

                    <div class="detail-item">
                      <small>ID:</small>
                      <p>{{ discount.id }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ng-template #noDiscounts>
              <p class="empty-message">Nenhum desconto adicionado</p>
            </ng-template>
          </div>
        </div>
      </mat-dialog-content>

      <mat-dialog-actions class="modal-footer">
        <button mat-stroked-button (click)="onClose()" class="btn btn-ghost">
          <mat-icon>close</mat-icon>
          Fechar
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
